import React from "react";
import { size } from "lodash";
import { IllustrationProps } from ".";

export default ({ colors, options: { emojis } }: IllustrationProps) => {
  return emojis
    ? getEmojiCloudIllustration()
    : getDefaultCloudIllustration(colors);
};

function getEmojiCloudIllustration() {
  return (
    <svg width="100%" height="100%" viewBox="0 0 440 120">
      <>
        <g>
          <path
            fill="#ffca28"
            d="M33 0a24.75 24.75 0 0125 24.5A24.75 24.75 0 0133 49 24.75 24.75 0 018 24.5 24.75 24.75 0 0133 0"
          />
          <path
            fill="#6d4c41"
            d="M41 27a6.22 6.22 0 01-6-6.4 1.5 1.5 0 113 0 3 3 0 106 0 1.5 1.5 0 113 0 6.22 6.22 0 01-6 6.4M25 27a6.22 6.22 0 01-6-6.4 1.5 1.5 0 113 0 3 3 0 106 0 1.5 1.5 0 113 0 6.22 6.22 0 01-6 6.4M43.37 41a1.61 1.61 0 01-1.15-.5 12.81 12.81 0 00-18.44 0 1.57 1.57 0 01-2.3 0 1.79 1.79 0 010-2.44 15.64 15.64 0 0123 0 1.79 1.79 0 010 2.44 1.59 1.59 0 01-1.15.5"
          />
          <path
            fill="#03a9f4"
            d="M20.31.75a1.52 1.52 0 00-2.62 0c-.78 1.48-4.69 9-4.69 11.9A6.19 6.19 0 0019 19a6.19 6.19 0 006-6.35c0-2.9-3.91-10.42-4.69-11.9"
          />
        </g>
        <g>
          <path
            fill="#ffca28"
            d="M126 0a24.26 24.26 0 0124 24.5 24 24 0 11-48 0A24.26 24.26 0 01126 0"
          />
          <path
            fill="#fafafa"
            d="M143.68 27.63a1.52 1.52 0 00-1.23-.63h-32.9a1.52 1.52 0 00-1.23.63 1.64 1.64 0 00-.26 1.41 18.51 18.51 0 0035.88 0 1.64 1.64 0 00-.26-1.41"
          />
          <path
            fill="#f44336"
            d="M120.52 12a5 5 0 00-2.52.69 5 5 0 00-2.52-.69 4.29 4.29 0 00-4.48 4.18c0 2.55 3.23 4.75 6.26 6.61a1.38 1.38 0 00.74.21 1.46 1.46 0 00.73-.2c3.26-2 6.27-4.11 6.27-6.62a4.29 4.29 0 00-4.48-4.18"
          />
          <path
            fill="#f44336"
            d="M138.52 12a5 5 0 00-2.52.69 5 5 0 00-2.52-.69 4.29 4.29 0 00-4.48 4.18c0 2.56 3.23 4.75 6.26 6.61a1.38 1.38 0 00.74.21 1.46 1.46 0 00.73-.2c3.26-2 6.27-4.11 6.27-6.62a4.29 4.29 0 00-4.48-4.18"
          />
        </g>
        <g>
          <path
            fill="#ffca28"
            d="M218 0a24.75 24.75 0 0125 24.5 25 25 0 01-50 0A24.75 24.75 0 01218 0"
          />
          <path
            fill="#6d4c41"
            d="M205.08 22.94a1.47 1.47 0 01.56-1.73 1 1 0 011.36.7 3.1 3.1 0 003.21 2.42 3.54 3.54 0 002.73-3.25c.1-.71.64-1.19 1.21-1.06a1.33 1.33 0 01.83 1.54c-.42 2.91-2.24 5.08-4.54 5.4s-4.45-1.29-5.36-4"
          />
          <path
            fill="#6d4c41"
            d="M225.56 27c-2.3-.32-4.12-2.49-4.54-5.4a1.33 1.33 0 01.83-1.54c.57-.13 1.11.35 1.21 1.06a3.55 3.55 0 002.73 3.25 3.09 3.09 0 003.21-2.46 1 1 0 011.36-.7 1.47 1.47 0 01.56 1.73c-.91 2.74-3.07 4.34-5.36 4"
          />
          <path fill="#6d4c41" d="M218 28a5 5 0 11-5 5 5 5 0 015-5" />
          <path
            fill="#f44336"
            d="M231 14.16V16h-8v-1.65c.63-.65 3.91-4 4.58-4.64h-4.25V8h7.4v1.49c-4 4.14-3.08 3.18-4.62 4.67zM243 10.47V13h-10v-2.26c.79-.91 4.89-5.57 5.72-6.39-.94.05-4.3 0-5.31 0V2h9.25v2.05c-5 5.7-3.85 4.37-5.77 6.42z"
          />
        </g>
        <g>
          <path
            fill="#ffca28"
            d="M174.5 70C188 70 199 80.52 199 93.5S188 117 174.5 117 150 106.48 150 93.5 161 70 174.5 70"
          />
          <path
            fill="#fafafa"
            d="M192.68 95.55a1.6 1.6 0 00-1.23-.55h-32.9a1.6 1.6 0 00-1.23.55 1.29 1.29 0 00-.26 1.23C159.31 104 166.68 109 175 109s15.69-5 17.94-12.22a1.29 1.29 0 00-.26-1.23"
          />
          <path fill="#6d4c41" d="M165 84a4 4 0 11-4 4 4 4 0 014-4" />
          <path fill="#6d4c41" d="M184 84a4 4 0 11-4 4 4 4 0 014-4" />
        </g>
        <g>
          <path
            fill="#ffca28"
            d="M369 70a24.5 24.5 0 11-25 24.5A24.75 24.75 0 01369 70"
          />
          <path
            fill="#fafafa"
            d="M387.67 97.63a1.66 1.66 0 00-1.31-.63h-34.72a1.66 1.66 0 00-1.31.63 1.58 1.58 0 00-.27 1.41 19.83 19.83 0 0037.88 0 1.58 1.58 0 00-.27-1.41"
          />
          <path
            fill="#6d4c41"
            d="M379.67 92a1.33 1.33 0 01-.8-.27l-5.34-4.13a1.41 1.41 0 010-2.2l5.34-4.12a1.29 1.29 0 011.86.27 1.41 1.41 0 01-.27 1.93l-3.91 3 3.92 3a1.41 1.41 0 01.26 1.92 1.31 1.31 0 01-1.06.55"
          />
          <path
            fill="#6d4c41"
            d="M358.33 92a1.31 1.31 0 01-1.06-.55 1.39 1.39 0 01.26-1.92l3.92-3-3.92-3a1.4 1.4 0 01-.26-1.93 1.29 1.29 0 011.86-.27l5.34 4.12a1.41 1.41 0 010 2.2l-5.34 4.13a1.33 1.33 0 01-.8.27"
          />
        </g>
        <g>
          <path
            fill="#ffca28"
            d="M328.58 29.92a4.53 4.53 0 00-1.31 4l1.66 9.7a4.57 4.57 0 01-6.62 4.81l-8.7-4.59a4.6 4.6 0 00-4.24 0l-8.7 4.59a4.55 4.55 0 01-6.6-4.81l1.66-9.7a4.61 4.61 0 00-1.31-4l-7-6.87a4.56 4.56 0 012.53-7.78l9.72-1.41a4.55 4.55 0 003.43-2.49l4.36-8.84a4.56 4.56 0 018.17 0l4.34 8.84a4.55 4.55 0 003.43 2.49l9.74 1.41a4.57 4.57 0 012.52 7.78z"
          />
        </g>
        <path
          fill="#f44336"
          d="M86.44 70A20.25 20.25 0 0076 73a20.27 20.27 0 00-10.44-3C55.14 70 47 77.84 47 87.86c0 10.93 13.38 20.32 25.93 28.25a5.75 5.75 0 006.1 0c13.49-8.36 26-17.58 26-28.28C105 77.84 96.86 70 86.44 70"
        />
        <g>
          <path
            fill="#ed694a"
            d="M283.81 84.4c-1-1.09-2.64-2.56-3.32.76a7.6 7.6 0 01-1.23 2.7 16.54 16.54 0 00-3.43-6.7 13.68 13.68 0 01-2.77-7.45.8.8 0 00-1.32-.51 21.4 21.4 0 00-7.31 16.09 11.16 11.16 0 01-3-4.54 1.05 1.05 0 00-1.85-.24 4.53 4.53 0 00-.26.4c-3.59 6.16-5.32 13.64-3.72 20.6 2.67 11.66 20.35 14.92 29.71 7.59 9.15-7.17 6.24-20.51-1.5-28.7"
          />
          <path
            fill="#f4a32c"
            d="M281.61 93.29c-.78-.79-2-1.86-2.49.55a5.31 5.31 0 01-.93 2 11.86 11.86 0 00-2.57-4.88 9.82 9.82 0 01-2.08-5.42.6.6 0 00-1-.36 15.38 15.38 0 00-5.48 11.69 8.06 8.06 0 01-2.24-3.29.81.81 0 00-1.4-.18l-.19.29c-2.69 4.48-4 9.92-2.79 15 2 8.47 15.26 10.84 22.28 5.51 6.87-5.21 4.68-14.91-1.12-20.87"
          />
          <path
            fill="#ffd93b"
            d="M278.41 100.7c-.52-.55-1.32-1.28-1.66.38a3.85 3.85 0 01-.62 1.35 8.2 8.2 0 00-1.71-3.35 6.81 6.81 0 01-1.42-3.73.4.4 0 00-.66-.25 10.72 10.72 0 00-3.66 8 5.47 5.47 0 01-1.49-2.26.53.53 0 00-.93-.13l-.13.2a14.41 14.41 0 00-1.86 10.31c1.34 5.82 10.18 7.45 14.86 3.79a7.22 7.22 0 002.79-5 12.28 12.28 0 00-3.54-9.37"
          />
          <path
            fill="#eae9e8"
            d="M276 108.85c-.28-.27-.73-.64-.92.19a1.74 1.74 0 01-.34.68 4 4 0 00-.95-1.68 3.23 3.23 0 01-.77-1.86.23.23 0 00-.37-.13 5.18 5.18 0 00-2 4 2.72 2.72 0 01-.83-1.13.31.31 0 00-.52-.06l-.07.1a6.57 6.57 0 00-1 5.15c1 4 9.3 3.86 9.8-.59a5.81 5.81 0 00-2-4.69"
          />
          <path
            fill="#d8553a"
            d="M264.5 76a3.75 3.75 0 000-6 3.75 3.75 0 000 6M290.29 88a3.49 3.49 0 000-6c-1.05.71-2.28 4.45 0 6M253.86 90a3.31 3.31 0 000-5c-.7.59-1.52 3.71 0 5M280 81a3.63 3.63 0 000-5 3.63 3.63 0 000 5"
          />
        </g>
        <g>
          <path
            fill="#ffca28"
            d="M407.5 0A24.5 24.5 0 11383 24.5 24.5 24.5 0 01407.5 0"
          />
          <path
            fill="#6d4c41"
            d="M417.27 34h-18.54c-.4 0-.73-.45-.73-1s.33-1 .73-1h18.54c.4 0 .73.45.73 1s-.33 1-.73 1M402.12 22h-5.24a1 1 0 010-2h5.24a1 1 0 010 2M418.12 22h-5.24a1 1 0 010-2h5.24a1 1 0 010 2"
          />
        </g>
      </>
    </svg>
  );
}

function getDefaultCloudIllustrationViewbox(
  isMonochrome: boolean,
  numberOfColors: number
) {
  if (isMonochrome || numberOfColors >= 5) return "0 0 306 110";
  if (numberOfColors >= 3) return "0 0 306 77";
  return "43 0 225 30";
}

function getDefaultCloudIllustration({ base, scheme }) {
  const numberOfColors = size(scheme);
  const _scheme = numberOfColors === 0 ? [base] : scheme;
  const isMonochrome = size(_scheme) === 1;
  const viewBox = getDefaultCloudIllustrationViewbox(
    isMonochrome,
    numberOfColors
  );
  return (
    <svg width="100%" height="100%" viewBox={viewBox}>
      <rect
        width={84}
        height={28}
        x={43}
        y={2}
        opacity={isMonochrome ? 0.6 : 1}
        rx={14}
        fill={_scheme[0]}
      />
      <rect
        width={129}
        height={30}
        x={139}
        y={1}
        opacity={isMonochrome ? 0.8 : 1}
        rx={15}
        fill={_scheme[isMonochrome ? 0 : 1]}
      />
      {(isMonochrome || numberOfColors >= 3) && (
        <rect
          width={116}
          height={28}
          y={45}
          opacity={isMonochrome ? 0.7 : 1}
          rx={14}
          fill={_scheme[isMonochrome ? 0 : 2]}
        />
      )}
      {(isMonochrome || numberOfColors >= 4) && (
        <rect
          width={175}
          height={36}
          x={131}
          y={41}
          opacity={isMonochrome ? 0.9 : 1}
          rx={18}
          fill={_scheme[isMonochrome ? 0 : 3]}
        />
      )}
      {(isMonochrome || numberOfColors >= 5) && (
        <rect
          width={116}
          height={22}
          x={95}
          y={88}
          opacity={isMonochrome ? 0.5 : 1}
          rx={11}
          fill={_scheme[isMonochrome ? 0 : 4]}
        />
      )}
    </svg>
  );
}
